import React from 'react'

import OrganizationLogo from 'src/components/OrganizationLogo'
import cloudinaryUrl from 'src/utils/cloudinaryUrl'
import isDefaultLogo from 'src/utils/isDefaultLogo'

const supportsCqw = CSS.supports('width', '50cqw')

const Preview = ({ donation, honoreeName }) =>
  <div
    className="position-relative"
    style={{ marginLeft: '-3.1%', marginRight: '-5.9%', aspectRatio: '1.8' }}
  >
    <img
      src={cloudinaryUrl(
        'widgets/donations/sympathy-card-template-t.png',
        { width: 524 * 2, fetchFormat: 'auto', quality: 'auto' },
        { mappingFolder: 'shared' }
      )}
      alt="Sympathy Card"
      className="img-fluid"
    />
    {
      supportsCqw &&
      <div
        className="position-absolute start-0 end-0 top-0 bottom-0"
        style={{ containerType: 'size' }}
      >
        <div className="position-relative h-100 text-center" style={{
          perspective: '200cqw',
          perspectiveOrigin: '250% 240%',
        }}>
          <div className="position-absolute" style={{
            top: '0.75%',
            left: '52.75%',
            right: '8.25%',
            maxHeight: '56%',
            overflow: 'hidden',
            backgroundColor: '#fff',
            borderRadius: '2cqw',
            padding: '3.25cqw 0',
            fontSize: '2cqw',
          }}>
            <p className="mb-0">
              In remembrance, a donation has been made to<br/>
              <b>{donation.partnerItem.beneficiary.name}</b>
            </p>
            {
              !isDefaultLogo(donation.partnerItem.beneficiary.logo_img) &&
              <div className="mx-auto" style={{
                width: 'max-content',
                marginTop: '3.75cqw',
              }}>
                <OrganizationLogo
                  organization={donation.partnerItem.beneficiary}
                  width={40}
                  height={40}
                />
              </div>
            }
          </div>
          <div className="position-absolute d-flex align-items-center justify-content-center" style={{
            top: '45%',
            left: '53%',
            right: '8.5%',
            bottom: '2%',
            transform: 'rotateX(24deg) rotateY(1deg) translateX(-25%)',
            transformOrigin: '300% 105%',
            backgroundColor: '#fff',
            fontSize: '2cqw',
            lineHeight: '1.75',
          }}>
            <p className="mb-0" style={{
              fontFamily: "'Iowan Old Style', 'Palatino Linotype', 'URW Palladio L', P052, serif",
            }}>
              <small style={{ textTransform: 'uppercase' }}>
                In memory of
              </small><br/>
              <span style={{ fontSize: '1.5em' }}>
                {honoreeName}
              </span><br/>
              <small>This gift honors their life and legacy.</small><br/>
              <i>With Love &amp; Sympathy:</i><br/>
              {donation.firstName || 'Donor'} {donation.lastName || 'Name'}
            </p>
          </div>
        </div>
      </div>
    }
  </div>

export default Preview
